import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  Router,
  RouterStateSnapshot,
  RoutesRecognized,
  UrlTree,
} from '@angular/router';
import { filter, Observable, pairwise } from 'rxjs';
import { FirestoreService } from 'src/app/shared/services/firestore.service';
import { UxserviceService } from 'src/app/shared/services/uxservice.service';
// import { GMUser } from 'src/app/shared/interfaces/user';

@Injectable({
  providedIn: 'root',
})
export class BusinessuserguardGuard implements CanActivateChild {
  constructor(
    private firestoreService: FirestoreService,
    private router: Router,
    private uxservice: UxserviceService,
  ) {}

  canActivateChild(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    let url: string = state.url;
    return this.checkUserRole(next, url, state);
  }

  async checkUserRole(
    route: ActivatedRouteSnapshot,
    url: any,
    state: any,
  ): Promise<boolean> {
    return new Promise(async (resolve) => {
      const res: any = await this.firestoreService.getAuthUserProfile();
      console.log(res);

      if (res && res.role) {
        if (res.role === 'business') {
          // 🚫 Check if Main Vendor account is disabled
          if (res.accountStatus === 'disabled') {
            this.uxservice.showMessage(
              'Your vendor account has been disabled by administration. Access to the Vendor Dashboard is restricted. Please contact support.',
              'Account Disabled',
              'error',
            );
            this.router.navigateByUrl('/');
            resolve(false);
            return;
          }
          resolve(true); // ✅ allow active business users
        } else if (res.role === 'worker' && !res.isdeleted) {
          // 🚫 Check if Parent Vendor is disabled
          if (res.parentUid) {
            try {
              const parentSnap: any = await this.firestoreService.getUserProfile(res.parentUid);
              if (parentSnap && parentSnap.accountStatus === 'disabled') {
                this.uxservice.showMessage(
                  'Your company account has been disabled by administration. Access to the Vendor Dashboard is restricted. Please contact support.',
                  'Account Disabled',
                  'error',
                );
                this.router.navigateByUrl('/');
                resolve(false);
                return;
              }
            } catch (e) {
              console.error('Error checking worker parent account status:', e);
            }
          }
          resolve(true); // ✅ allow active workers of active vendors
        } else {
          // 🚦 Redirect based on role
          if (res.role === 'customer') {
            this.router.navigateByUrl('/customer');
          } else if (res.role === 'servicemanager') {
            this.router.navigateByUrl('/servicemanager');
          } else if (res.role === 'productmanager') {
            this.router.navigateByUrl('/productmanager');
          } else if (res.role === 'admin') {
            this.router.navigateByUrl('/admin');
          } else if (res.role === 'worker' && res.isdeleted) {
            this.router.navigateByUrl('/');
          }
          resolve(false);
        }
      } else {
        this.router.navigateByUrl('/');
        resolve(false);
      }
    });
  }
}
